import type { CameraPlacement } from "@studystraight/shared-types";

/** 6 screen của §8. */
export type Screen =
  | "home"
  | "setup"
  | "calibration"
  | "monitoring"
  | "report"
  | "history"
  | "settings";

/**
 * State của một phiên đang được thiết lập.
 *
 * `placement` **đóng băng** từ lúc rời Camera Setup cho tới hết phiên: baseline được hiệu chỉnh
 * theo một placement cụ thể (`PostureBaseline.placement`), đổi giữa phiên sẽ khiến mọi delta so
 * với baseline trở thành vô nghĩa. Đổi placement = bắt buộc calibrate lại.
 */
export interface SessionSetup {
  placement: CameraPlacement;
}

export const defaultSessionSetup: SessionSetup = { placement: "FRONTAL" };
